module.exports = __webpack_public_path__ + "stylesheets/section-different-devices_0ec793bed54add9e7e9d6aa5977b35fc.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/sections/section-different-devices.less
// module id = LxjB
// module chunks = 153